import { IReleaseNote } from "../types"

export const RELEASE_1_4_7: IReleaseNote = {
    status: "PAST",
    title: "v1.4.7",
    date: "11th October 2024",
    releaseType: "Patch",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "Patch 1.4.7 includes a bug fix relating to the commissioning submission API that was triggering an incorrect error message",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "This release contains no changes to your functionality",
        },
        {
            heading: "For installers using our APIs",
            content: "The following change has been been added:",
            bullets: [
                "We have updated the logic for the Commission submission application, enabling users to retrieve the correct error message",
            ],
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            content: "This release contains no changes to your functionality",
        },
        {
            heading: "For DNOs using our APIs",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
}
